import { AxiosResponse } from "axios";

import API from "../api";

import { Fleet, IUploadCentreCreateFleetList } from "../models/fleet";


const ROUTE_NAME = "fleets";

const FleetService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getById(id: number, options?: any): Promise<AxiosResponse<Fleet>> {
    return await API.get(`/${ROUTE_NAME}/${id}`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<Fleet[]>> {
    return await API.get(`/${ROUTE_NAME}`, { params: options });
  },
  async create(fleet: Fleet): Promise<AxiosResponse<Fleet>> {
    return await API.post(`/${ROUTE_NAME}`, fleet);
  },
  async update(id: number, fleet: Fleet): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, fleet);
  },
  async delete(id: number): Promise<AxiosResponse<Fleet>> {
    return await API.delete(`/${ROUTE_NAME}/${id}`);
  },
  async postCSV(data: IUploadCentreCreateFleetList[]): Promise<AxiosResponse<Fleet[]>> {
    return await API.post(`/${ROUTE_NAME}/list`, data);
  },
};

export default FleetService;
